export const experienceData = [
    {
        id: 1,
        company: 'SOCIOLLA, GURGAON ',
        jobtitle: 'Full Stack Lead - SDE 4',
        startYear: '2022',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'SOCIOLLA, GURGAON ',
        jobtitle: 'Full Stack Developer - SDE 3',
        startYear: '2020',
        endYear: '2022'
    },
    {
        id: 3,
        company: 'Kashware, GURGAON ',
        jobtitle: 'Senior Software Developer - SDE 2',
        startYear: 'May 2022',
        endYear: 'Aug 2022'
    },
    {
        id: 4,
        company: 'UNICOMMERCE ESOLUTIONS PVT. LTD., GURGAON',
        jobtitle: 'Application Engineer',
        startYear: '2018',
        endYear: '2020'
    },
    {
        id: 5,
        company: 'HELIOS WEB SERVICES, JAIPUR',
        jobtitle: 'Software Developer',
        startYear: '2016',
        endYear: '2018'
    },
    {
        id: 6,
        company: 'MR. P MEDIAWORKS, JAIPUR',
        jobtitle: 'WEB DEVELOPER',
        startYear: '2015',
        endYear: '2016'
    },
]